<div class="page-title-area">
  <div class="container">
    <div class="page-title-content">
      <ul>
        <li>Listado de Gerenciadoras</li>
        <li><app-menu></app-menu></li>
      </ul>
      <h2>Gerenciadoras</h2>
    </div>
  </div>
</div>

<app-spinner [show]="!flagLoaded" [type]="'fullscreen'" [color]="'#B1476A'" [trackColor]="'#4CA7C8'" [text]="'Cargando gerenciadoras...'" [showText]="true" [blurBackground]="true"></app-spinner>

<div *ngIf="flagLoaded" class="profile-area pb-70">
  <div class="container">
    <div class="profile-courses-quizzes">
      <h3>Listado de Gerenciadoras</h3>
      <br>
      <a routerLink="/gerenciadoras-alta">
        <button mat-raised-button mat-button color="secondary">
          <mat-icon aria-hidden="false" aria-label="Example home icon">add</mat-icon> 
          Nueva Gerenciadora
        </button>
      </a>
      <br>
      <hr>
      
      <mat-form-field>
        <mat-label>Filtrar por nombre</mat-label>
        <input matInput (keyup)="applyFilter($event)" 
               placeholder="Gerenciadora..." 
               autocomplete="off" 
               #input>
      </mat-form-field>

      <div class="mat-elevation-z8">
        <table mat-table [dataSource]="dataSource" matSort>
          
          <ng-container matColumnDef="nombre">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Gerenciadora</th>
            <td mat-cell *matCellDef="let element">{{element.nombre || 'SIN DATOS'}}</td>
          </ng-container>
          
          <ng-container matColumnDef="activa">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Activo </th>
            <td mat-cell *matCellDef="let element">
              <div class="toggler">
                <input 
                  type="checkbox" 
                  [id]="'toggler-' + element._id" 
                  [checked]="element.activa || false"
                  (change)="toggleActiva(element, $event)">
                <label [for]="'toggler-' + element._id"></label>
              </div>
            </td>
          </ng-container>
          
          <ng-container matColumnDef="_id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Acciones</th>
            <td mat-cell *matCellDef="let element">
              <button style="margin-right: 5px;" 
                      (click)="verGerencia(element._id)" 
                      type="button"
                      title="Modificar datos de la gerenciadora" 
                      class="btn btn-warning">
                <i class="fas fa-edit"></i>
              </button>
            </td>
          </ng-container>
          
          <tr class="mat-row" *matNoDataRow="let row; when: noDataFilter">
            <td class="mat-cell" colspan="3">No se encontraron resultados para "{{input.value}}"</td>
          </tr>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row 
              *matRowDef="let row; columns: displayedColumns; when: hasData" 
              [class.inactive-row]="!row.activo"
              class="example-element-row">
          </tr>
        </table>
        
        <mat-paginator [pageSizeOptions]="[50, 100, 150, 200, 500, 800]" 
                      aria-label="Select page of gerenciadoras">
        </mat-paginator>
      </div>
    </div>
  </div>
</div>